"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createNewSectionEvent = exports.removeNewSectionEvent = exports.getOnLoadPageContent = exports.SetAddSectionModalPositionMessage = exports.GetClickedContentMessage = exports.BrowserContentStatusMessage = exports.SetBrowserContentMessage = exports.SetAddSectionModalMessage = exports.FindElementStatusMessage = exports.GetChangePageContentMessage = exports.GetPageContentMessage = exports.GetPageContentRequestMessage = exports.SetElementBackgroundColorMessage = exports.SelectHighlightElementMessage = exports.PageLoadStatusMessage = exports.ReloadUrlAckMessage = exports.ReloadUrlMessage = exports.Action = void 0;
var uuid_1 = require("uuid");
var Action;
(function (Action) {
    Action[Action["RELOAD_URL"] = 0] = "RELOAD_URL";
    Action[Action["RELOAD_URL_ACK"] = 1] = "RELOAD_URL_ACK";
    Action[Action["PAGE_LOAD_STATUS"] = 2] = "PAGE_LOAD_STATUS";
    Action[Action["SELECT_HIGHLIGHT_ELEMENT"] = 3] = "SELECT_HIGHLIGHT_ELEMENT";
    Action[Action["SET_ELEMENT_BACKGROUND_COLOR"] = 4] = "SET_ELEMENT_BACKGROUND_COLOR";
    Action[Action["GET_PAGE_CONTENT_REQUEST"] = 5] = "GET_PAGE_CONTENT_REQUEST";
    Action[Action["GET_PAGE_CONTENT"] = 6] = "GET_PAGE_CONTENT";
    Action[Action["GET_CHANGE_PAGE_CONTENT"] = 7] = "GET_CHANGE_PAGE_CONTENT";
    Action[Action["FIND_ELEMENT_STATUS"] = 8] = "FIND_ELEMENT_STATUS";
    Action[Action["SET_ADD_SECTION_MODAL"] = 9] = "SET_ADD_SECTION_MODAL";
    Action[Action["SET_BROWSER_CONTENT"] = 10] = "SET_BROWSER_CONTENT";
    Action[Action["BROWSER_CONTENT_STATUS"] = 11] = "BROWSER_CONTENT_STATUS";
    Action[Action["CLICKED_ON_CONTENT"] = 12] = "CLICKED_ON_CONTENT";
    Action[Action["SET_ADD_SECTION_MODAL_POSITION"] = 13] = "SET_ADD_SECTION_MODAL_POSITION";
    Action[Action["PAGE_LOAD_CONTENT"] = 14] = "PAGE_LOAD_CONTENT";
    Action[Action["REMOVE_NEW_SECTION_EVENT"] = 15] = "REMOVE_NEW_SECTION_EVENT";
    Action[Action["CREATE_NEW_SECTION_EVENT"] = 16] = "CREATE_NEW_SECTION_EVENT";
})(Action = exports.Action || (exports.Action = {}));
var ReloadUrlMessage = /** @class */ (function () {
    function ReloadUrlMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.RELOAD_URL;
        this.data = data;
    }
    return ReloadUrlMessage;
}());
exports.ReloadUrlMessage = ReloadUrlMessage;
var ReloadUrlAckMessage = /** @class */ (function () {
    function ReloadUrlAckMessage(id, data) {
        this.action = Action.RELOAD_URL_ACK;
        this.id = id;
        this.data = data;
    }
    return ReloadUrlAckMessage;
}());
exports.ReloadUrlAckMessage = ReloadUrlAckMessage;
var PageLoadStatusMessage = /** @class */ (function () {
    function PageLoadStatusMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.PAGE_LOAD_STATUS;
        this.data = data;
    }
    return PageLoadStatusMessage;
}());
exports.PageLoadStatusMessage = PageLoadStatusMessage;
var SelectHighlightElementMessage = /** @class */ (function () {
    function SelectHighlightElementMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.SELECT_HIGHLIGHT_ELEMENT;
        this.data = data;
    }
    return SelectHighlightElementMessage;
}());
exports.SelectHighlightElementMessage = SelectHighlightElementMessage;
var SetElementBackgroundColorMessage = /** @class */ (function () {
    function SetElementBackgroundColorMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.SET_ELEMENT_BACKGROUND_COLOR;
        this.data = data;
    }
    return SetElementBackgroundColorMessage;
}());
exports.SetElementBackgroundColorMessage = SetElementBackgroundColorMessage;
var GetPageContentRequestMessage = /** @class */ (function () {
    function GetPageContentRequestMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.GET_PAGE_CONTENT_REQUEST;
        this.data = data;
    }
    return GetPageContentRequestMessage;
}());
exports.GetPageContentRequestMessage = GetPageContentRequestMessage;
var GetPageContentMessage = /** @class */ (function () {
    function GetPageContentMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.GET_PAGE_CONTENT;
        this.data = data;
    }
    return GetPageContentMessage;
}());
exports.GetPageContentMessage = GetPageContentMessage;
var GetChangePageContentMessage = /** @class */ (function () {
    function GetChangePageContentMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.GET_CHANGE_PAGE_CONTENT;
        this.data = data;
    }
    return GetChangePageContentMessage;
}());
exports.GetChangePageContentMessage = GetChangePageContentMessage;
var FindElementStatusMessage = /** @class */ (function () {
    function FindElementStatusMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.FIND_ELEMENT_STATUS;
        this.data = data;
    }
    return FindElementStatusMessage;
}());
exports.FindElementStatusMessage = FindElementStatusMessage;
var SetAddSectionModalMessage = /** @class */ (function () {
    function SetAddSectionModalMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.SET_ADD_SECTION_MODAL;
        this.data = data;
    }
    return SetAddSectionModalMessage;
}());
exports.SetAddSectionModalMessage = SetAddSectionModalMessage;
var SetBrowserContentMessage = /** @class */ (function () {
    function SetBrowserContentMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.SET_BROWSER_CONTENT;
        this.data = data;
    }
    return SetBrowserContentMessage;
}());
exports.SetBrowserContentMessage = SetBrowserContentMessage;
var BrowserContentStatusMessage = /** @class */ (function () {
    function BrowserContentStatusMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.BROWSER_CONTENT_STATUS;
        this.data = data;
    }
    return BrowserContentStatusMessage;
}());
exports.BrowserContentStatusMessage = BrowserContentStatusMessage;
var GetClickedContentMessage = /** @class */ (function () {
    function GetClickedContentMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.CLICKED_ON_CONTENT;
        this.data = data;
    }
    return GetClickedContentMessage;
}());
exports.GetClickedContentMessage = GetClickedContentMessage;
var SetAddSectionModalPositionMessage = /** @class */ (function () {
    function SetAddSectionModalPositionMessage(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.SET_ADD_SECTION_MODAL_POSITION;
        this.data = data;
    }
    return SetAddSectionModalPositionMessage;
}());
exports.SetAddSectionModalPositionMessage = SetAddSectionModalPositionMessage;
var getOnLoadPageContent = /** @class */ (function () {
    function getOnLoadPageContent(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.PAGE_LOAD_CONTENT;
        this.data = data;
    }
    return getOnLoadPageContent;
}());
exports.getOnLoadPageContent = getOnLoadPageContent;
var removeNewSectionEvent = /** @class */ (function () {
    function removeNewSectionEvent(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.REMOVE_NEW_SECTION_EVENT;
        this.data = data;
    }
    return removeNewSectionEvent;
}());
exports.removeNewSectionEvent = removeNewSectionEvent;
var createNewSectionEvent = /** @class */ (function () {
    function createNewSectionEvent(data) {
        this.id = (0, uuid_1.v4)();
        this.action = Action.CREATE_NEW_SECTION_EVENT;
        this.data = data;
    }
    return createNewSectionEvent;
}());
exports.createNewSectionEvent = createNewSectionEvent;
//# sourceMappingURL=Message.js.map